export const rolesTableConf = [
  {
    field: 'role_name',
    title: 'Role Name'
  },
  {
    field: 'inherits',
    title: 'Inherits'
  },
  {
    field: 'permissions',
    title: 'Permissions'
  }
];
